// extracted by mini-css-extract-plugin
module.exports = {"section":"PageSection_section__cCkyo","title":"PageSection_title__8epK-"};